export interface JobFile {
  id: string;
  job_id: string;
  organization_id: string;
  uploader_user_id: string;
  uploader_role: 'client' | 'vendor';
  visibility_level: 'private' | 'public' | 'award_only' | 'client_visible';
  filename: string;
  original_filename: string;
  file_size_bytes: number;
  content_type: string;
  storage_key: string;
  file_category: string;
  file_version: number;
  replaced_file_id?: string;
  description?: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
  public_id: string;
}

export interface FileUploadData {
  file: File;
  visibility_level: JobFile['visibility_level'];
  file_category: JobFile['file_category'];
  description?: string;
}

export const MAX_FILE_SIZE = 200 * 1024 * 1024; // 200MB

export const ALLOWED_FILE_TYPES = [
  'application/pdf',
  'image/jpeg',
  'image/png',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'text/csv',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel',
  'application/zip',
  'text/plain'
];

export const VISIBILITY_OPTIONS = {
  client: [
    { 
      value: 'private' as const, 
      label: 'Private - Only I can see this file', 
      description: 'File is only visible to you' 
    },
    { 
      value: 'public' as const, 
      label: 'Public - Any vendor can see during RFQ', 
      description: 'Visible to all vendors during RFQ phase' 
    },
    { 
      value: 'award_only' as const, 
      label: 'Vendor Only - Only awarded vendor can see', 
      description: 'Visible to awarded vendor after job is awarded' 
    },
  ],
  vendor: [
    { 
      value: 'private' as const, 
      label: 'Private - Only I can see this file', 
      description: 'File is only visible to you' 
    },
    { 
      value: 'client_visible' as const, 
      label: 'Client Visible - Client and I can see', 
      description: 'Visible to both you and the client' 
    },
  ]
};

export const FILE_CATEGORIES = [
  { value: 'general', label: 'General' },
  { value: 'specifications', label: 'Specifications' },
  { value: 'artwork_files', label: 'Artwork Files' },
  { value: 'deliverables', label: 'Deliverables' },
  { value: 'proof_of_delivery', label: 'Proof of Delivery' },
  { value: 'proofs', label: 'Proofs' },
];